// @ts-nocheck
/* =============================================================
   Refund Options Page
   To remap API endpoints or field names, edit RTO_CONFIG only.
   ============================================================= */

const RTO_CONFIG = {
  // API 1 — Order service. AWB is POSTed as an array in the request body.
  // NOTE: ips.includ.com must have CORS enabled for the Shopify store origin.
  ORDER_SERVICE_URL: 'https://ips.includ.com/asp-service/asp-order-service/order-item-status-snapshot/v1/order-item-by-awb',

  // API 2 — Coupon request. Body is the raw AWB string.
  COUPON_ENDPOINT: 'https://ips.includ.com/asp-service/asp-order-service/customer-order-request/v1/rto-coupon-refund',

  CREDIT_BONUS_PCT: 0.10,

  SHOP_URL:         '/',
  SUPPORT_WHATSAPP: 'https://wa.me/919958258111?text=Hi',

  FIELDS: {
    orderId:        'order_id',
    awb:            'awb',
    refundAmount:   'refund_amount',
    creditAmount:   'credit_amount',
    bonusAmount:    'bonus_amount',
    isClaimed:      'is_claimed',
    lineItems:      'line_items',
    itemName:       'name',
    itemColorLabel: 'color_label',
    itemColorHex:   'color_hex',
    itemSize:       'size',
    itemPrice:      'price',
    itemImage:      'image_url',
  },
};

function field(obj, key) {
  return obj[RTO_CONFIG.FIELDS[key]];
}

/* ----------------------------------------------------------
   Transform API 1 response → internal normalised shape
---------------------------------------------------------- */
function transformOrderData(apiResponse) {
  const items = apiResponse.result;

  const isPartialPrepaid = items[0].paymentMode === 'COD'
    && items.some(item => (item.prepaidAmount ?? 0) > 0);

  const refundAmount = items.reduce((sum, item) => {
    const amt = isPartialPrepaid
      ? (item.prepaidAmount ?? 0)
      : (item.lineItemSellingPrice ?? 0);
    return sum + amt;
  }, 0);
  const creditAmount = Math.round(refundAmount * (1 + RTO_CONFIG.CREDIT_BONUS_PCT));
  const bonusAmount  = creditAmount - Math.round(refundAmount);

  const refundProcessed = items.some(item => (item.orderLineItemRefundAmount ?? 0) > 0);
  const viaDiscount     = items.some(item => item.refundDiscountCoupon != null);

  return {
    order_id:          items[0].orderName,
    awb:               items[0].trackingNumber,
    refund_amount:     Math.round(refundAmount),
    credit_amount:     creditAmount,
    bonus_amount:      bonusAmount,
    refund_processed:  refundProcessed,
    via_discount:      viaDiscount,
    is_claimed:        !refundProcessed && viaDiscount,
    line_items: items.map(item => ({
      name:        item.itemName,
      color_label: item.color,
      color_hex:   null,
      size:        item.size,
      price:       isPartialPrepaid ? (item.prepaidAmount ?? item.lineItemSellingPrice) : item.lineItemSellingPrice,
      image_url:   item.imageUrl,
    })),
  };
}

/* ----------------------------------------------------------
   Helpers
---------------------------------------------------------- */
function fmt(n) {
  return '₹' + Number(n).toLocaleString('en-IN');
}

function esc(str) {
  return String(str ?? '').replace(/[&<>"']/g, c =>
    ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])
  );
}

/* ----------------------------------------------------------
   Screen management
---------------------------------------------------------- */
const SCREEN_IDS = ['loading', 'error', 'offer', 'success', 'declined', 'processed'];

function showScreen(name) {
  SCREEN_IDS.forEach(id => {
    const el = document.getElementById('rto-screen-' + id);
    if (el) el.hidden = (id !== name);
  });
  window.scrollTo({ top: 0, behavior: 'instant' });
}

/* ----------------------------------------------------------
   Renderers
---------------------------------------------------------- */
function setText(selector, value) {
  document.querySelectorAll(selector).forEach(el => (el.textContent = value));
}

function buildItemHTML(item) {
  const imgUrl = field(item, 'itemImage');
  const hex    = field(item, 'itemColorHex');
  const label  = field(item, 'itemColorLabel') || '';
  const size   = field(item, 'itemSize');
  const price  = field(item, 'itemPrice');
  const name   = field(item, 'itemName') || '';

  const thumb = imgUrl
    ? `<img src="${esc(imgUrl)}" alt="${esc(name)}" width="58" height="58" loading="lazy">`
    : `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" width="30" height="30"><path d="M4 7l4-3 4 3 4-3 4 3-2 3v9H6v-9z"/></svg>`;

  const swatch = hex ? `<span class="swatch" style="background:${esc(hex)}" aria-hidden="true"></span>` : '';
  const sub = [
    label ? `<span>${swatch}${esc(label)}</span>` : '',
    size  ? `<span>·</span><span>${esc(size)}</span>` : '',
  ].filter(Boolean).join('');

  return `<div class="item">
    <div class="thumb ${imgUrl ? 'thumb-img' : ''}">${thumb}</div>
    <div class="item-info">
      <div class="item-name">${esc(name)}</div>
      <div class="item-sub">${sub}</div>
    </div>
    <div class="item-price">${fmt(price)}</div>
  </div>`;
}

function renderOffer(data) {
  setText('[data-rto-order-id]',   field(data, 'orderId'));
  setText('[data-rto-awb]',        field(data, 'awb'));
  setText('[data-rto-refund]',     fmt(field(data, 'refundAmount')));
  setText('[data-rto-credit]',     fmt(field(data, 'creditAmount')));
  setText('[data-rto-bonus-pill]', `That's ${fmt(field(data, 'bonusAmount'))} extra, on us 🎁`);
  setText('[data-rto-default-note]',
    `Prefer cash? No action needed — your ${fmt(field(data, 'refundAmount'))} will auto-refund to your original payment method within 5–7 working days.`);

  const container = document.getElementById('rto-items');
  if (container) container.innerHTML = (field(data, 'lineItems') || []).map(buildItemHTML).join('');

  showScreen('offer');
}

function renderSuccess() {
  showScreen('success');
  fireConfetti();
}

function renderRefundProcessed(viaDiscount) {
  const el = document.getElementById('rto-processed-msg');
  if (el) el.textContent = viaDiscount
    ? 'Refund for this package is already processed via Discount code'
    : 'Refund for this package is already processed to Original payment mode';
  showScreen('processed');
}

function renderDeclined(refundAmount) {
  document.getElementById('rto-declined-amount').textContent = fmt(refundAmount);
  showScreen('declined');
}

function renderError(message) {
  const el = document.getElementById('rto-error-message');
  if (el) el.textContent = message || 'Unable to load your order. Please try again.';
  const wa = document.getElementById('rto-error-whatsapp');
  if (wa) wa.href = RTO_CONFIG.SUPPORT_WHATSAPP;
  showScreen('error');
}

/* ----------------------------------------------------------
   API
---------------------------------------------------------- */
async function fetchOrderByAWB(awb) {
  const res = await fetch(RTO_CONFIG.ORDER_SERVICE_URL, {
    method:  'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body:    JSON.stringify([awb]),
  });
  if (!res.ok) throw new Error('http_' + res.status);
  return res.json();
}

async function requestCoupon(awb) {
  const res = await fetch(RTO_CONFIG.COUPON_ENDPOINT, {
    method:  'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body:    awb,  // raw AWB string, matching curl --data
  });
  if (!res.ok) throw new Error('http_' + res.status);
  return res.json();
}

function showOfferError(message) {
  const wrap = document.getElementById('rto-offer-error');
  const msg  = document.getElementById('rto-offer-error-msg');
  if (!wrap || !msg) return;
  msg.textContent = message;
  wrap.hidden = false;
  wrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
}

/* ----------------------------------------------------------
   Generate-coupon button
---------------------------------------------------------- */
const generateBtn   = document.getElementById('rto-generate-btn');
const GENERATE_ICON = generateBtn ? generateBtn.innerHTML : '';
let   _generating   = false;

function setGenerating(on) {
  _generating = on;
  generateBtn.disabled = on;
  generateBtn.innerHTML = on
    ? `<span class="btn-spinner" aria-hidden="true"></span> Generating…`
    : GENERATE_ICON;
}

if (generateBtn) {
  generateBtn.addEventListener('click', async () => {
    if (_generating) return;
    const errWrap = document.getElementById('rto-offer-error');
    if (errWrap) errWrap.hidden = true;
    setGenerating(true);
    try {
      const res = await requestCoupon(_awb);
      if (res.successful && (res.result?.status === 'SUCCESS' || res.result?.status === 'IN_PROGRESS')) {
        renderSuccess();
      } else {
        showOfferError(res.result?.comment || res.message || 'Something went wrong. Please try again.');
        setGenerating(false);
      }
    } catch {
      showOfferError('Unable to submit your request. Please try again.');
      setGenerating(false);
    }
  });
}

/* ----------------------------------------------------------
   Decline button
---------------------------------------------------------- */
const declineBtn = document.getElementById('rto-decline-btn');
if (declineBtn) declineBtn.addEventListener('click', () => renderDeclined(_refundAmount));

/* ----------------------------------------------------------
   Copy button
---------------------------------------------------------- */
const copyBtn = document.getElementById('rto-copy-btn');
if (copyBtn) {
  copyBtn.addEventListener('click', function () {
    const code = document.getElementById('rto-coupon-code').textContent.trim();
    const markDone = () => {
      this.classList.add('done');
      this.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" width="14" height="14"><path d="M20 6L9 17l-5-5"/></svg> Copied`;
      setTimeout(() => {
        this.classList.remove('done');
        this.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14"><rect x="9" y="9" width="11" height="11" rx="2"/><path d="M5 15V5a2 2 0 0 1 2-2h10"/></svg> Copy`;
      }, 1800);
    };
    // "Copied" only when the code really is on the clipboard.
    const failed = () => window.includToast?.('Could not copy the code', { type: 'error' });
    navigator.clipboard ? navigator.clipboard.writeText(code).then(markDone, failed) : failed();
  });
}

/* ----------------------------------------------------------
   Confetti
---------------------------------------------------------- */
function fireConfetti() {
  const c = document.getElementById('rto-confetti');
  if (!c) return;
  c.innerHTML = '';
  const colors = ['#FF5C39', '#FFC83D', '#13A06A', '#E8421C', '#FFD9AE'];
  for (let i = 0; i < 26; i++) {
    const p = document.createElement('i');
    p.style.cssText = `left:${(Math.random() * 100).toFixed(1)}%;background:${colors[i % colors.length]};animation-delay:${(Math.random() * 0.4).toFixed(2)}s;animation-duration:${(1.1 + Math.random() * 0.8).toFixed(2)}s`;
    c.appendChild(p);
  }
  setTimeout(() => (c.innerHTML = ''), 2400);
}

/* ----------------------------------------------------------
   Init
---------------------------------------------------------- */
let _awb          = null;
let _refundAmount = null;

async function init() {
  showScreen('loading');
  _awb = new URLSearchParams(window.location.search).get('awb');

  if (!_awb) {
    renderError('No tracking number found. Please use the link sent to your WhatsApp.');
    return;
  }

  try {
    const apiResponse = await fetchOrderByAWB(_awb);

    if (!apiResponse.successful || !apiResponse.result?.length) {
      renderError('No order found for this tracking number.');
      return;
    }

    const data = transformOrderData(apiResponse);
    _refundAmount = data.refund_amount;

    if (data.refund_processed) {
      renderRefundProcessed(data.via_discount);
      return;
    }

    if (data.is_claimed) {
      renderSuccess();
      return;
    }

    renderOffer(data);

  } catch {
    renderError('Unable to load your order details. Please try again or contact support.');
  }
}

document.addEventListener('DOMContentLoaded', init);
